export default __webpack_public_path__ + "static/media/halloween.9d28b9a1.png";